import React from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

import StallList from "./components/stallList";
import StallDetails from "./components/stallDetails";
import RegistrationStall from "./components/registrationStall";
import Invitation from "./components/invitation";

// function ReloadGuard({ children }) {
//   const location = useLocation();

//   const navEntry = performance.getEntriesByType("navigation")[0];
//   const isReload = navEntry?.type === "reload";

//   // Redirect ONLY if:
//   // 1) Page is refreshed
//   // 2) User is NOT already on home
//   // 3) Route is stall details
//   if (
//     isReload &&
//     location.pathname !== "/" &&
//     location.pathname.startsWith("/stall")
//   ) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// }

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<StallList />} />
          <Route path="/register" element={<RegistrationStall />} />
          <Route path="/stall/:id" element={<StallDetails />} />
          <Route path="/invitation/:stallNo" element={<Invitation />} />
        </Routes>
    </Router>
  );
}

export default App;
